import axios, { AxiosResponse } from 'axios';
import { ApiResponse, zps_wp } from '../zps';

export type IProduct = {
  entid: number;
  name: string;
  price: number;
  productid: string;
};

export interface IProductRequest {
  name: string;
  price: number;
  productid: string;
}

export interface IProductResponse extends ApiResponse {
  list: IProduct[];
  type: string;
  totalRows?: number;
}

export const fetchProductsList = (productid?: number): Promise<AxiosResponse<IProductResponse>> => {
  const url = productid ? `${zps_wp}/api/product?productid=${productid}` : `${zps_wp}/api/product`;
  return axios.get<IProductResponse>(url);
};

export const fetchProductDetails = (productid: number): Promise<AxiosResponse<IProductResponse>> => {
  const url = `${zps_wp}/api/product?productid=${productid}`;
  return axios.get<IProductResponse>(url);
};

export const addProductDetails = (
  request: IProductRequest,
  controller: AbortController
): Promise<AxiosResponse<ApiResponse>> => {
  const url = `${zps_wp}/api/product`;
  return axios.post<ApiResponse>(url, request, { signal: controller.signal });
};

export const updateProductDetails = (
  request: IProductRequest,
  controller: AbortController
): Promise<AxiosResponse<ApiResponse>> => {
  const url = `${zps_wp}/api/product`;
  return axios.put<ApiResponse>(url, request, { signal: controller.signal });
};

export const deleteProduct = (entid: number, productid: string): Promise<AxiosResponse<ApiResponse>> => {
  const url = `${zps_wp}/api/product?entid=${entid}&productid=${productid}`;
  return axios.delete<ApiResponse>(url);
};
